(()=>{
  const drawer=document.querySelector('[data-senlo-cart-drawer]');
  if(!drawer)return;
  const panel=drawer.querySelector('.senlo-cart-drawer__panel');
  const itemsEl=drawer.querySelector('[data-cart-drawer-items]');
  const foot=drawer.querySelector('[data-cart-drawer-foot]');
  const totalEl=drawer.querySelector('[data-cart-drawer-total]');
  const countEl=document.getElementById('allLength');
  let lastFocus=null;
  const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
  const money=(cents,currency)=>{
    const code=currency||drawer.dataset.currency||'USD';
    try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:code}).format((Number(cents)||0)/100);}
    catch(e){return ((Number(cents)||0)/100).toFixed(2)+' '+code;}
  };
  const open=()=>{
    lastFocus=document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('senlo-cart-open');
    setTimeout(()=>drawer.querySelector('[data-cart-close]')?.focus(),30);
  };
  const close=()=>{
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('senlo-cart-open');
    if(lastFocus&&typeof lastFocus.focus==='function')lastFocus.focus();
  };
  const render=cart=>{
    if(countEl)countEl.textContent=cart.item_count;
    if(!cart.items?.length){
      itemsEl.innerHTML='<div class="senlo-cart-drawer__empty"><strong>Your cart is empty</strong><span>Add a product to get started.</span></div>';
      foot.hidden=true;
      return;
    }
    itemsEl.innerHTML=cart.items.map(item=>{
      const variant=item.variant_title&&item.variant_title!=='Default Title'?'<p class="senlo-cart-drawer__variant">'+esc(item.variant_title)+'</p>':'<p class="senlo-cart-drawer__variant"></p>';
      const image=item.image?'<a class="senlo-cart-drawer__image" href="'+esc(item.url)+'"><img src="'+esc(item.image)+'" alt="'+esc(item.product_title)+'"></a>':'<div class="senlo-cart-drawer__image"></div>';
      return '<article class="senlo-cart-drawer__item" data-cart-key="'+esc(item.key)+'">'+image+
        '<div class="senlo-cart-drawer__info"><a class="senlo-cart-drawer__title" href="'+esc(item.url)+'">'+esc(item.product_title)+'</a>'+variant+
        '<div class="senlo-cart-drawer__row"><div class="senlo-cart-drawer__qty"><button type="button" data-cart-dec aria-label="Decrease quantity">−</button><input type="number" min="1" value="'+item.quantity+'" data-cart-qty aria-label="Quantity"><button type="button" data-cart-inc aria-label="Increase quantity">+</button></div><span class="senlo-cart-drawer__price">'+money(item.final_line_price,cart.currency)+'</span></div>'+
        '<button class="senlo-cart-drawer__remove" type="button" data-cart-remove>Remove</button></div></article>';
    }).join('');
    totalEl.textContent=money(cart.total_price,cart.currency);
    foot.hidden=false;
  };
  const load=async shouldOpen=>{
    drawer.classList.add('is-busy');
    try{
      const response=await fetch(drawer.dataset.cartJsonUrl,{headers:{'Accept':'application/json'}});
      const cart=await response.json();
      render(cart);
      if(shouldOpen)open();
    }finally{drawer.classList.remove('is-busy');}
  };
  const change=async(key,quantity)=>{
    drawer.classList.add('is-busy');
    try{
      const response=await fetch(drawer.dataset.cartChangeUrl,{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:key,quantity:Math.max(0,Number(quantity)||0)})
      });
      const cart=await response.json();
      render(cart);
    }finally{drawer.classList.remove('is-busy');}
  };
  document.addEventListener('click',e=>{
    const trigger=e.target.closest('[data-cart-trigger]');
    if(trigger&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey&&e.button===0){e.preventDefault();load(true);return;}
    if(e.target.closest('[data-cart-close]')){close();return;}
    const item=e.target.closest('[data-cart-key]');
    if(!item)return;
    const key=item.dataset.cartKey;
    const input=item.querySelector('[data-cart-qty]');
    const qty=Math.max(1,Number(input?.value)||1);
    if(e.target.closest('[data-cart-inc]'))change(key,qty+1);
    if(e.target.closest('[data-cart-dec]'))change(key,Math.max(0,qty-1));
    if(e.target.closest('[data-cart-remove]'))change(key,0);
  });
  itemsEl.addEventListener('change',e=>{
    const input=e.target.closest('[data-cart-qty]');
    if(!input)return;
    const item=input.closest('[data-cart-key]');
    if(item)change(item.dataset.cartKey,Math.max(1,Number(input.value)||1));
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&drawer.classList.contains('is-open'))close();});
  document.addEventListener('senlo:cart:updated',()=>load(true));
})();